var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "nav" }, [
    _c("div", { staticClass: "logo", on: { click: _vm.returnHome } }, [
      _c("img", {
        attrs: { src: require("../../assets/" + _vm.$regional.iconPath) }
      })
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "menu-container scroll" },
      _vm._l(_vm.menuItems, function(item, index) {
        return _c(
          "div",
          {
            key: index + item.value,
            class: _vm.activeMenu === item.link ? "menu active" : "menu",
            on: {
              click: function($event) {
                return _vm.changeMenu(item)
              }
            }
          },
          [
            _c("span", {
              staticClass: "colorful img",
              style: {
                "-webkit-mask": "url(" + item.src + ") no-repeat",
                mask: "url(" + item.src + ") no-repeat",
                "background-color":
                  _vm.activeMenu === item.link ? "var(--theme-color)" : "#fff"
              }
            }),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(item.name))])
          ]
        )
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-0048ba58", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-0048ba58","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/common/NavBar.vue
// module id = null
// module chunks = 